"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("./context");

var root_1 = require("./styled/root");

var Pagination = function Pagination(_a) {
  var __UIScope = _a.__UIScope,
      children = _a.children,
      className = _a.className,
      currentPage = _a.currentPage,
      isInverse = _a.isInverse,
      _b = _a.nextLabel,
      nextLabel = _b === void 0 ? 'Next page' : _b,
      onChange = _a.onChange,
      _c = _a.pageLabel,
      pageLabel = _c === void 0 ? 'Go to page' : _c,
      _d = _a.prevLabel,
      prevLabel = _d === void 0 ? 'Previous page' : _d,
      _e = _a.titleLabel,
      titleLabel = _e === void 0 ? 'Pagination' : _e,
      _f = _a.currentLabel,
      currentLabel = _f === void 0 ? 'Current page' : _f,
      totalPages = _a.totalPages;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Pagination',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var value = (0, react_1.useMemo)(function () {
    return {
      onChange: onChange,
      currentPage: currentPage,
      totalPages: totalPages,
      nextLabel: nextLabel,
      prevLabel: prevLabel,
      pageLabel: pageLabel,
      currentLabel: currentLabel,
      isInverse: isInverse
    };
  }, [onChange, currentPage, totalPages, nextLabel, prevLabel, pageLabel, currentLabel, isInverse]);
  return react_1.default.createElement(root_1.Root, {
    role: "navigation",
    "aria-label": titleLabel,
    className: rootClasses
  }, react_1.default.createElement(context_1.PaginationContext.Provider, {
    value: value
  }, children));
};

var PaginationWithSpace = (0, ui_helper_with_space_1.withSpace)(Pagination);
exports.Pagination = PaginationWithSpace;